<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.times-circle-light"></svg-vue>
          <h1 class="content-title">
            {{ $t('Ending cashbook register') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/home">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="closeCashbook">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Current cash in till information') }}
              </h3>
              <p class="form-description-text">{{ $t('Enter cash till for new cashbook register') }}.</p>
            </div>
            <div class="md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-4">
                <div class="col-span-3">
                  <div class="flex items-center">
                    <label class="min-w-32 block font-bold uppercase">{{ $t('Cashbook opening') }}</label>
                    <span class="mr-4 inline-block">:</span>
                    <div>{{ cashbook.created_at }}</div>
                  </div>
                  <div class="flex items-center">
                    <label class="min-w-32 block font-bold uppercase">{{ $t('Working person') }}</label>
                    <span class="mr-4 inline-block">:</span>
                    <div>{{ cashbook.user }}</div>
                  </div>
                </div>
                <div class="col-span-3 text-xs">
                  <div class="flex justify-between">
                    <label class="min-w-32 block text-xl font-semibold uppercase">{{ $t('Total cash in at openning') }}</label>
                    <div class="text-xl">{{ cashbook.total_cash_in | currency }}</div>
                  </div>
                  <p class="form-description-text flex justify-between px-2">
                    {{ $t('Credit amounts') }} <span>{{ $t('Incomings') }}</span>
                  </p>
                  <div class="mb-1 bg-green-50 rounded-md p-1 border border-gray-400">
                    <div class="flex justify-between px-2 py-1">
                      <label class="min-w-32 block font-semibold uppercase">[+] {{ $t('Total sale amount') }}</label>
                      <div>{{ cashbook.total_sale_amount | currency }}</div>
                    </div>
                    <div class="flex justify-between px-2 py-1">
                      <label class="min-w-32 block font-semibold uppercase">[+] {{ $t('Total repair amount') }}</label>
                      <div>{{ cashbook.total_repair_amount | currency }}</div>
                    </div>
                     <div class="flex justify-between px-2 py-1">
                      <label class="min-w-32 block  uppercase">[+] {{ $t('Total repair due recovery') }}</label>
                      <div>{{ cashbook.total_due_recovery | currency }}</div>
                    </div>
                     <div class="flex justify-between px-2 py-1">
                      <label class="min-w-32 block font-semibold uppercase">[=] {{ $t('Total sum up') }}</label>
                      <div>{{ (cashbook.total_repair_amount + cashbook.total_sale_amount + cashbook.total_due_recovery) | currency }}</div>
                    </div>
                  </div>
                  <p class="form-description-text flex justify-between px-2">
                    {{ $t('Debet amounts') }} <span>{{ $t('Outgoings') }}</span>
                  </p>
                  <div class="mb-1 bg-red-50 rounded-md p-1 border border-gray-400">
                    <div class="flex justify-between px-2 py-1">
                      <label class="min-w-32 block font-semibold uppercase">[-] {{ $t('Total bill amount') }}</label>
                      <div>{{ cashbook.total_bill_amount | currency }}</div>
                    </div>
                    <div class="flex justify-between px-2 py-1">
                      <label class="min-w-32 block font-semibold uppercase">[-] {{ $t('Total refund amount') }}</label>
                      <div>{{ cashbook.total_refund_amount | currency }}</div>
                    </div>
                    <div class="flex justify-between px-2 py-1">
                      <label class="min-w-32 block font-semibold uppercase">[-] {{ $t('Total purchase price') }}</label>
                      <div>{{ cashbook.total_custom_purchase_amount | currency }}</div>
                    </div>
                  </div>
                  <div class="col-span-3 my-2">
                    <p class="form-description-text flex justify-between px-2">
                      {{ $t('Payment filteration') }}
                      <span>{{ $t('Cash in till and cash in card') }}</span>
                    </p>
                    <div class="bg-gray-50 rounded-md p-1 border border-gray-400">
                      <div class="flex justify-between px-2 py-1">
                        <label class="min-w-32 block font-semibold uppercase">{{ $t('Paid via cash') }}</label>
                        <div>{{ cashbook.cash_in_till | currency }}</div>
                      </div>
                      <div class="flex justify-between px-2 py-1">
                        <label class="min-w-32 block font-semibold uppercase">{{ $t('Paid via card') }}</label>
                        <div>{{ cashbook.cash_in_card | currency }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-between px-2 py-1">
                    <label class="min-w-32 block font-semibold uppercase">
                      {{ $t('Grand amount') }}
                      <span class="form-description-text text-xs">[{{ $t('Cash in') }} + {{ $t('Incomings') }} - {{ $t('Outgoings') }}]</span>
                    </label>
                    {{ cashbook.total_cash_out | currency }}
                  </div>
                  <div class="flex justify-between px-2 py-1">
                    <label class="min-w-32 block text-lg font-semibold uppercase">
                      {{ $t('Till amount') }}
                      <span class="form-description-text text-xs">[{{ $t('Grand') }} - {{ $t('Paid via card') }}]</span>
                    </label>
                    <div class="text-lg">
                      {{ (cashbook.total_cash_out - cashbook.cash_in_card) | currency }}
                    </div>
                  </div>
                  <div class="col-span-3">
                    <label class="form-label">{{ $t('Expense amount') }}</label>
                    <input type="number" v-model="cashbook.expense_amount" class="form-input" />
                  </div>
                  <div class="flex justify-between px-2 py-1">
                    <label class="min-w-32 block text-xl font-semibold uppercase">
                      {{ $t('Amount after expenses') }}
                      <span class="form-description-text text-xs">[{{ $t('Grand till amount') }} - {{ $t('expense amount') }}]</span>
                    </label>
                    <div class="text-xl">
                      {{ (cashbook.total_cash_out - cashbook.cash_in_card - cashbook.expense_amount) | currency }}
                    </div>
                  </div>
                  <div class="p-2 flex">
                    <input type="checkbox" class="mt-1" id="agreed" v-model="agreed" />
                    <label class="form-label px-2" for="agreed">{{ $t('I acept the information is being matched to process.') }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <router-link class="btn btn-app shadow-sm rounded-md mr-4" to="/">{{ $t('Cancel') }}</router-link>
              <button :disabled="!agreed" class="btn btn-red shadow-sm rounded-md" type="submit">
                {{ $t('Close') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'cash-in',
  metaInfo() {
    return {
      title: this.$i18n.t('Open register'),
    };
  },
  data() {
    return {
      loading: true,
      agreed: false,
      cashbook: {
        total_cash_in: 0,
        total_sale_amount: 0,
        total_repair_amount: 0,
        total_bill_amount: 0,
        total_refund_amount: 0,
        total_custom_purchase_amount: 0,
        total_cash_out: 0,
        cash_in_till: 0,
        cash_in_card: 0,
        expense_amount: 0,
      },
    };
  },
  mounted() {
    this.getCashbook();
  },

  methods: {
    getCashbook() {
      this.loading = true;
      axios
        .post(route('cashbook-closing'))
        .then((response) => {
          this.cashbook = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$router.push(`/cashbook-open`);
        });
    },
    closeCashbook() {
      this.loading = true;
      axios
        .put(route('cash-books.update', this.cashbook.uuid), this.cashbook)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push(`/print/cashbook/${this.cashbook.uuid}`);
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
